import { createClient } from "@supabase/supabase-js";
import { isSupabaseConfigured, supabaseAnonKey, supabaseUrl } from "./config";
import { resilientSupabaseStorage } from "./authStorage";
import { createAuthSessionFetch } from "./authSessionFetch";

export const supabase = isSupabaseConfigured
  ? createClient(supabaseUrl, supabaseAnonKey, {
      global: { fetch: createAuthSessionFetch(supabaseUrl) },
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        flowType: "implicit",
        storage: resilientSupabaseStorage,
      },
    })
  : null;
